





































/* General */

/* Mixins */
import SearchableDropdownMixin from '@/mixins/searchable-dropdown.mixin'

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'
import { IProjectForSelection } from '@/api/types/response.types'

/* API */

export default SearchableDropdownMixin.extend({
  name: 'IfpFilterEntities',

  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    entityOptions: {
      type: Array as () => IProjectForSelection[],
      required: true,
    },
  },

  data() {
    return {
      TextAssistant,
      showDropdown: false,

      /* SearchableDropdownMixin configuration */
      allowMultipleSelections: true,
    }
  },

  computed: {
    totalOptionsCount(): number {
      return this.entityOptions.length
    },
    filteredOptions(): IProjectForSelection[] {
      if (this.filterQuery.length === 0) {
        return this.entityOptions
      }

      return this.entityOptions.filter(entity => {
        return entity.name
          .toLowerCase()
          .includes(this.filterQuery.toLowerCase())
      })
    },
    selectedEntities(): IProjectForSelection[] {
      return this.entityOptions.filter(s => this.selectedIds.includes(s.id))
    },
    hasSelectedEntities(): boolean {
      return this.selectedEntities.length > 0
    },
    selectedEntitiesLabel(): string {
      if (!this.hasSelectedEntities) {
        return ''
      }
      if (this.selectedEntities.length === 1) {
        return this.selectedEntities[0].name
      }
      return `${this.selectedEntities.length} selected`
    },
  },

  methods: {
    entityIconClass(entity: IProjectForSelection): string {
      if (entity.isFavorite) {
        return `ddi ddi-star-filled`
      }
      return `ddi ddi-${TextAssistant.entitySingularName(
        this.entityType,
      ).toLowerCase()}`
    },
  },
})
